import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import Loader from "../components/Loader";
import Pagination from "../components/Pagination";
import reportService from "../services/reportService";

const WalletHistory = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;

  useEffect(() => {
    fetchWalletHistory();
  }, []);

  const fetchWalletHistory = async () => {
    try {
      setLoading(true);
      const res = await reportService.getWalletHistory();
      if (res && res.success) {
        setHistory(res.history || []);
      }
    } catch (err) {
      toast.error("Failed to load wallet transaction history.");
    } finally {
      setLoading(false);
    }
  };

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const closeSidebar = () => setSidebarOpen(false);

  const totalPages = Math.ceil(history.length / itemsPerPage) || 1;
  const currentItems = history.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  return (
    <div className="d-flex flex-column min-vh-100 bg-[#07080e] text-white">
      <Navbar toggleSidebar={toggleSidebar} />

      <div className="d-flex flex-grow-1 position-relative">
        <Sidebar isOpen={sidebarOpen} closeMobileSidebar={closeSidebar} />

        <main className="flex-grow-1 p-3 p-md-4 overflow-auto">
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center mb-4 pb-2 border-bottom border-secondary/20">
              <div>
                <h2 className="fw-bold text-white font-serif mb-1">VIP Wallet History</h2>
                <p className="text-gray-400 mb-0">Detailed ledger of coin deposits, withdrawals, and game transfers.</p>
              </div>
              <button className="btn btn-outline-gold btn-sm fw-bold px-3 py-2" onClick={fetchWalletHistory}>
                <i className="bi bi-arrow-clockwise me-1"></i> Refresh Ledger
              </button>
            </div>


            <div className="card border-0 shadow-sm rounded-3 bg-white overflow-hidden">
              <div className="card-body p-0">
                {loading ? (
                  <Loader message="Loading wallet transactions..." />
                ) : history.length === 0 ? (
                  <div className="text-center py-5">
                    <i className="bi bi-wallet2 text-muted display-4"></i>
                    <h5 className="fw-bold mt-3 text-secondary">No Wallet Logs</h5>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-hover align-middle mb-0">
                      <thead className="table-light">
                        <tr>
                          <th className="ps-4">Tx ID</th>
                          <th>Sender</th>
                          <th>Receiver</th>
                          <th>Amount</th>
                          <th>Type</th>
                          <th>Note</th>
                          <th>Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems.map((w) => (
                          <tr key={w.id}>
                            <td className="ps-4 fw-bold">#{w.id}</td>
                            <td className="fw-medium">{w.sender || "Shop / System"}</td>
                            <td className="fw-bold text-primary">{w.receiver || "Me"}</td>
                            <td className="fw-bold text-success">🪙 {Number(w.amount || 0).toLocaleString()}</td>
                            <td><span className="badge bg-secondary">{w.type || "TRANSFER"}</span></td>
                            <td
                              className="small"
                              style={{
                                color: "#334155",
                                fontWeight: 500,
                              }}
                            >
                              {w.note || "-"}
                            </td>

                            <td
                              className="small"
                              style={{
                                color: "#475569",
                                fontWeight: 500,
                                whiteSpace: "nowrap",
                              }}
                            >
                              {w.created_at
                                ? new Date(w.created_at).toLocaleString("en-IN")
                                : "N/A"}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
              {!loading && history.length > 0 && (
                <div className="card-footer bg-white border-top p-3">
                  <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={setCurrentPage} />
                </div>
              )}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default WalletHistory;
